import { ADD_OPENED_WINDOW, REMOVE_OPENED_WINDOW, REMOVE_OPENED_WINDOWS, SET_ONETIME, SET_REGULAR } from '../constants';

export const openWindow = (data) => {
  return {
    type: ADD_OPENED_WINDOW,
    data: data,
  };
};

export const closeWindow = (id) => {
  return {
    type: REMOVE_OPENED_WINDOW,
    id: id,
  };
};

export const closeWindows = () => {
  return {
    type: REMOVE_OPENED_WINDOWS,
  };
};

export const setOnetime = (data) => {
  return {
    type: SET_ONETIME,
    data: data,
  };
};

export const setRegular = (data) => {
  return {
    type: SET_REGULAR,
    data: data,
  };
};
